module.exports = "../fonts/SFUIText-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SFUIText-Regular.woff
// module id = 570
// module chunks = 0